export default __webpack_public_path__ + "static/media/M_Macaco.45b41551.mp3";